// プリントサービス関連の表示/非表示切り替え処理
function togglePrintServiceVisibility(checkbox, container) {
  container.style.display = checkbox.checked ? 'block' : 'none';
}

document.getElementById('print-service-1').addEventListener('change', function (e) {
  const val = e.target.value;
  if (val === 'hyakumangoku') {
    document.getElementById('print-service-count').value = '1';
    document.getElementById('print-service-container-2').style.display = 'none';
    document.getElementById('print-service-container-3').style.display = 'none';
    document.getElementById('print-service-count').disabled = true;
  } else {
    document.getElementById('print-service-count').disabled = false;
  }
});

function togglePrintServiceOptions(selectElement, contentContainer) {
  const selectedValue = selectElement.value;
  contentContainer.querySelectorAll('.print-service-content').forEach(el => {
    el.style.display = 'none';
  });
  if (selectedValue !== 'none') {
    const target = contentContainer.querySelector(`#print-service-${selectedValue}`);
    if (target) {
      target.style.display = 'block';
    }
  }

  // 印刷場所の表示/非表示切り替え
  const printLocation = contentContainer.querySelector('.print-service-location');
  if (selectedValue === 'hyakumangoku') {
    printLocation.style.display = 'none';
  } else {
    printLocation.style.display = 'block';
  }

  // 入力フィールドをリセット
  const nameInput = contentContainer.querySelector('input[name="properties[name]"]');
  const textInput = contentContainer.querySelector('input[name="properties[text]"]');
  if (nameInput) nameInput.value = '';
  if (textInput) textInput.value = '';

  validateForm();
}

document.getElementById('print-service_checkbox1').addEventListener('change', function (e) {
  togglePrintServiceVisibility(this, document.getElementById('print-service-count-container'));
  validateForm();
});

document.getElementById('print-service-count').addEventListener('change', function (e) {
  const val = Number(e.target.value);
  document.getElementById('print-service-container-2').style.display = val >= 2 ? 'block' : 'none';
  document.getElementById('print-service-container-3').style.display = val === 3 ? 'block' : 'none';
  const hyakumangokuOptions = document.querySelectorAll('option[value="hyakumangoku"]');
  if (val > 1) {
    hyakumangokuOptions.forEach(option => {
      option.disabled = true; // 選択不可にする
    });
  } else {
    hyakumangokuOptions.forEach(option => {
      option.disabled = false; // 選択可能にする
    });
  }
  validateForm();
});

document.querySelectorAll('.print-service-container select, .print-service-container input').forEach(element => {
  element.addEventListener('change', validateForm);
});

function validateForm() {
  const printServiceCheckbox = document.getElementById('print-service_checkbox1');
  const printServiceCount = document.getElementById('print-service-count');
  const addCartButton = document.querySelector('.js-add-cart-button');
  const errorContainer = document.getElementById('print-service-error');
  let errorMessage = '';

  if (!printServiceCheckbox.checked) {
    addCartButton.disabled = false;
    errorContainer.style.display = 'none';
    return;
  }

  const selectedCount = parseInt(printServiceCount.value, 10);
  let isValid = true;

  for (let i = 1; i <= selectedCount; i++) {
    const container = document.getElementById(`print-service-container-${i}`);
    const select = container.querySelector('select');
    const locationSelect = container.querySelector(`#print-location-${i}`);

    if (select.value === 'none') {
      isValid = false;
      errorMessage = 'プリントする内容を選択してください。';
      break;
    }

    if (select.value !== 'hyakumangoku' && (!locationSelect.value || locationSelect.value === 'none')) {
      isValid = false;
      errorMessage = 'プリントする位置を選択してください。';
      break;
    }

    if (select.value === 'name') {
      const nameInput = container.querySelector('input[name="properties[name]"]');
      if (!nameInput || nameInput.value.trim() === '') {
        isValid = false;
        errorMessage = '名前を入力してください。';
        break;
      }
    } else if (select.value === 'text') {
      const textInput = container.querySelector('input[name="properties[text]"]');
      if (!textInput || textInput.value.trim() === '') {
        isValid = false;
        errorMessage = 'テキストを入力してください。';
        break;
      }
    }
  }

  addCartButton.disabled = !isValid;
  if (!isValid) {
    errorContainer.textContent = errorMessage;
    errorContainer.style.display = 'block';
  } else {
    errorContainer.style.display = 'none';
  }
}

// カート追加処理
document.querySelector('.js-add-cart-button').addEventListener('click', function (e) {
  e.preventDefault();

  const form = this.closest('form');
  // 多言語対応するため、formのaction属性を取得して該当するformを取得
  const actionPath = form.getAttribute('action');
  const productForm = document.querySelector(`form[action="${actionPath}"]`);
  const originalProductId = productForm.querySelector('select[name="id"]').value;
  const originalQuantity = productForm.querySelector('select[name="quantity"]').value;
  const isPrintServiceSelected = document.querySelector('#print-service_checkbox1').checked;

  let relatedItemColor = "";
  try {
    // "clickyboxes-option-color-" ID を持つ要素の中から選択中(active)の色を取得
    const selectedColorElement = document.querySelector('ul[id^="clickyboxes-option-color-"] a.active');
    if (selectedColorElement) {
      relatedItemColor = selectedColorElement.getAttribute('data-value');
    }
  } catch (error) {
    console.error("カラー情報の取得中にエラーが発生しました: ", error);
  }

  const getCheckedValue = (name, index) => form.querySelector(`input[name="${name}-${index}"]:checked`)?.value || null;
  const getSelectedColor = (index) => {
    const container = document.getElementById(`print-service-container-${index}`);
    const selectedOption = container.querySelector('select').value;
    const radio = form.querySelector(`input[data-color-index="data-color-${selectedOption}-${index}"]:checked`);
    if (radio) {
      const colorClass = Array.from(radio.classList).find(cls => cls.startsWith('print-color-'));
      return colorClass ? colorClass.replace('print-color-', '') : null;
    }
    return null;
  };

  const selectedColors1 = getSelectedColor(1);
  const selectedColors2 = getSelectedColor(2);
  const selectedColors3 = getSelectedColor(3);

  const logoVariant1 = getCheckedValue('logo-radio', 1);
  const logoVariant2 = getCheckedValue('logo-radio', 2);
  const logoVariant3 = getCheckedValue('logo-radio', 3);

  const imageVariant1 = getCheckedValue('image-radio', 1);
  const imageVariant2 = getCheckedValue('image-radio', 2);
  const imageVariant3 = getCheckedValue('image-radio', 3);

  const imageHyakumangokuVariant1 = getCheckedValue('hyakumangoku-image-radio', 1);
  const imageHyakumangokuVariant2 = getCheckedValue('hyakumangoku-image-radio', 2);
  const imageHyakumangokuVariant3 = getCheckedValue('hyakumangoku-image-radio', 3);

  const imageKutaniVariant1 = getCheckedValue('kutani-image-radio', 1);
  const imageKutaniVariant2 = getCheckedValue('kutani-image-radio', 2);
  const imageKutaniVariant3 = getCheckedValue('kutani-image-radio', 3);

  const constellationVariant1 = getCheckedValue('constellation-image-radio', 1);
  const constellationVariant2 = getCheckedValue('constellation-image-radio', 2);
  const constellationVariant3 = getCheckedValue('constellation-image-radio', 3);

  const printServiceSelect1 = form.querySelector('#print-service-1');
  const printServiceSelect2 = form.querySelector('#print-service-2');
  const printServiceSelect3 = form.querySelector('#print-service-3');

  let selectedValue1 = printServiceSelect1.value;
  let selectedValue2 = printServiceSelect2.value;
  let selectedValue3 = printServiceSelect3.value;

  if (!isPrintServiceSelected) {
    selectedValue1 = selectedValue2 = selectedValue3 = null;
  }

  const idMap = {
    'logo': [logoVariant1, logoVariant2, logoVariant3],
    'image': [imageVariant1, imageVariant2, imageVariant3],
    'hyakumangoku': [imageHyakumangokuVariant1, imageHyakumangokuVariant2, imageHyakumangokuVariant3],
    'kutani': [imageKutaniVariant1, imageKutaniVariant2, imageKutaniVariant3],
    'constellation': [constellationVariant1, constellationVariant2, constellationVariant3]
  };

  // 商品URL取得
  const currentURL = window.location.href;
  const urlParts = currentURL.split('?')[0].split('/');
  const productValue = urlParts[urlParts.length - 1];
  const searchParams = new URLSearchParams(currentURL.split('?')[1] || '');
  const variantValue = searchParams.get('variant');
  const relatedItemParam = variantValue ? `?variant=${variantValue}` : '';
  const relatedItem = productValue + relatedItemParam;

  // プリントテキスト取得
  function getPrintText(container, serviceNumber) {
    const nameInput = container.querySelector(`#print-service-${serviceNumber}-content input[name="properties[name]"]`);
    const textInput = container.querySelector(`#print-service-${serviceNumber}-content input[name="properties[text]"]`);
    return {
      name: nameInput?.value.trim() || '',
      text: textInput?.value.trim() || ''
    };
  }

  const printText1 = getPrintText(form, 1);
  const printText2 = getPrintText(form, 2);
  const printText3 = getPrintText(form, 3);

  // 印刷場所取得
  function getPrintLocation(form, serviceNumber) {
    return form.querySelector(`#print-location-${serviceNumber}`).value;
  }

  const printLocation1 = getPrintLocation(form, 1);
  const printLocation2 = getPrintLocation(form, 2);
  const printLocation3 = getPrintLocation(form, 3);

  // 商品情報構築
  const items = [{ 
    id: originalProductId, 
    quantity: originalQuantity,
    properties: {
      'timestamp': new Date().toISOString().slice(0, 19).replace('T', ' ') // 秒までのフォーマット
    }
  }];

  function addPrintServiceItem(selectedValue, printText, selectedColors, printLocation, index) {
    if (isPrintServiceSelected && selectedValue) {
      let itemId;
      if (selectedValue === 'name') {
        itemId = '43054881013949';
      } else if (selectedValue === 'text') {
        itemId = '43054881079485';
      } else if (idMap[selectedValue] && idMap[selectedValue][index - 1]) {
        itemId = idMap[selectedValue][index - 1];
      }
  
      if (itemId) {
        const properties = {
          'relatedItem': relatedItem, 
          'timestamp': new Date().toISOString().slice(0, 19).replace('T', ' '), // 秒までのフォーマット
          'relatedItemColor': relatedItemColor || 'Unknown'  // ★カラー情報を追加★
        };
        if (printText.name) properties['name'] = printText.name;
        if (printText.text) properties['text'] = printText.text;
        // selectedValueが特定のオプションの場合のみprint-colorを追加
        if (selectedColors && (selectedValue === 'name' || selectedValue === 'text' || selectedValue === 'logo' )) {
          properties['print-color'] = selectedColors;
        }
        if (selectedValue !== 'hyakumangoku') {
          properties['printLocation'] = printLocation;
        }
  
        items.push({
          id: itemId,
          quantity: 1,
          properties: properties
        });
      }
    }
  }

  addPrintServiceItem(selectedValue1, printText1, selectedColors1, printLocation1, 1);
  addPrintServiceItem(selectedValue2, printText2, selectedColors2, printLocation2, 2);
  addPrintServiceItem(selectedValue3, printText3, selectedColors3, printLocation3, 3);

  // カート追加処理
  fetch("/cart/add.js", {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items })
  })
    .then(response => {
      if (response.ok) {
        console.log("商品がカートに追加されました。");
        setTimeout(function() {
          window.location.href = "/cart";
        }, 1000);
      } else {
        return response.json().then(data => {
          console.error("商品をカートに追加できませんでした。", data);
        });
      }
    })
    .catch(error => {
      console.error("エラーが発生しました: ", error);
    });
});

// プリントサービスコンテンツ切り替え処理
[1, 2, 3].forEach(i => {
  const selectElement = document.getElementById(`print-service-${i}`);
  const contentContainer = document.getElementById(`print-service-${i}-content`);
  if (selectElement && contentContainer) {
    selectElement.addEventListener('change', () => togglePrintServiceOptions(selectElement, contentContainer));
  }
});